const preReqTypes = {
  FETCH_TYPE_OF_LOAD_START: "FETCH_TYPE_OF_LOAD_START",
  FETCH_TYPE_OF_LOAD_SUCCESS: "FETCH_TYPE_OF_LOAD_SUCCESS",

  SUBMIT_PREREQ_START: "SUBMIT_PREREQ_START",
  SUBMIT_PREREQ_SUCCESS: "SUBMIT_PREREQ_SUCCESS",

  SET_PREREQ_LoadId: "SET_PREREQ_LoadId",

  RESPONSE_NEW_INSTANT_REQUEST: "RESPONSE_NEW_INSTANT_REQUEST",
  SET_SHOWN_SUPPORT: "SET_SHOWN_SUPPORT",
};

export default preReqTypes;
